import { getSession } from "../../app/state/appSessionStorage"

export interface AuthHeader {
  headers: Record<string, string>
}

export const withAuthHeader = (): Partial<AuthHeader> => {
  const { token, email, oauthIdToken, clientId } = getSession()
  if (token) {
    const headers = {
      "X-USER-TOKEN": `${token}`,
      "X-USER-EMAIL": `${email}`,
      "X-CLIENT-ID": `${clientId}`
    }
    return { headers }
  }
  if (!token && oauthIdToken) {
    const headers = {
      "Authorization": `Bearer ${oauthIdToken}`,
    }
    return { headers }

  }
  return {
    headers: {
      "X-CLIENT-ID": `${clientId}`
    }
  }
}
